import React from "react";
import {PiCircuitryFill, PiFactory, PiUserCircle} from "react-icons/pi"

function IconUserType (props) {
    return(
        props.children === 'client' ? <PiUserCircle className="me-1 mb-1" size={'1.3em'}/> : <PiFactory className="text-secondary me-1 mb-1" size={'1.3em'}/>
    );
}

export default IconUserType;